import type { DataTableColumn } from '@repo/mantine-datatable';
import type { MouseEvent, ReactNode } from 'react';
import type { IBaseModel } from '../../api';
import type { FilterOptionType } from '../Filter';

export type ExtendedDataTableColumn<T> = DataTableColumn<T> & {
	titleLabel: string;
	navigate?: boolean;
	esAccessor?: string;
	customProperty?: boolean;
	filterOptionType?: FilterOptionType | string;
	explicit?: boolean;
};

export type Render<T> = (record: T, index: number) => ReactNode;

export type OnCellClickHandlerParams<T extends IBaseModel> = {
	event: MouseEvent;
	record: T;
	recordIndex: number;
	column: ExtendedDataTableColumn<T>;
	columnIndex: number;
};

export type ActionProperty =
	| 'collections'
	| 'tags'
	| 'owners'
	| 'published'
	| 'pii'
	| 'verified'
	| 'owners_groups'
	| 'assigned_to'
	| 'assigned_to_group'
	| 'priority'
	| 'status'
	| 'parent'
	| 'teams';

export const RESOURCE_LABEL = 'resource';
